/* istanbul ignore file */
import { Component, computed, inject, input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MedpaceTextareaAutocompleteComponent } from '@components/atoms/textarea-autocomplete/medpace-textarea-autocomplete.component';
import { CardMode } from '@components/card/card.component';
import { OtherRequestDetailsFormGroup } from '@components/request/travel-request-card/form-groups/detail-form-groups/travel/other-request.formgroup';
import { MedpaceAutocompleteObject } from '@models/medpaceAutocompleteObject';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { getUniqueObjects } from '@utility/utility';

@Component({
    selector: 'medpace-other-request-details',
    templateUrl: './other-request-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MedpaceTextareaAutocompleteComponent],
})
export class OtherRequestDetailsComponent {
    private readonly travelViewModelService = inject(TravelViewModelService);

    public readonly mode = input.required<CardMode>();
    public readonly formGroup = input.required<OtherRequestDetailsFormGroup>();

    public readonly autocompleteOptions: Signal<{
        specialRequests: MedpaceAutocompleteObject[];
    }> = computed(() => ({
        specialRequests: getUniqueObjects(
            this.travelViewModelService
                .travelCardViewModel()
                ?.historyData.other.map((data) => ({ requestDate: data.requestDate, value: data.specialRequest })) ?? []
        ),
    }));
}
